// import { useBreakpointValue,useTokens } from "@gemini/core" deactivated because of SSR issues
// waiting for gemini fix
import { useMemo } from "react";
import { IS_SERVER } from "@/constants";
import { useEffect, useState } from "react";
import { useTokens } from "@gemini/core";
//temp Hook to get the breakpoint value for desktop and mobile (waiting for gemini fix for useBreakpointValue)
const useCDPBreakpointValue = (values, fallback) => {
    const [value, setValue] = useState(undefined);
    const tokens = useTokens();
    useEffect(() => {
        if (IS_SERVER)
            return;
        const mediaQuery = window.matchMedia(`(min-width: ${tokens["breakpoint.lg"]}px)`);
        const updateValue = () => {
            setValue(mediaQuery.matches ? values.lg : values.base);
        };
        updateValue(); // initial check
        mediaQuery.addEventListener("change", updateValue);
        return () => {
            mediaQuery.removeEventListener("change", updateValue);
        };
    }, [values, fallback, tokens]);
    return value;
};
export function useIsDesktopOrMobile() {
    const breakpoint = useCDPBreakpointValue({ base: "mobile", lg: "desktop" });
    return useMemo(() => {
        if (IS_SERVER) {
            return {
                userDevice: undefined,
                isDesktopCSR: false,
                isMobileCSR: false,
            };
        }
        return {
            userDevice: breakpoint,
            isDesktopCSR: breakpoint === "desktop",
            isMobileCSR: breakpoint === "mobile",
        };
    }, [breakpoint]);
}
